import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import '@plathunt/ui/tokens.css';
import { AppProviders } from './app/providers.js';
import { router } from './app/routes.js';

const container = document.getElementById('root');
if (!container) throw new Error('#root nicht gefunden.');

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
